import React, { useEffect, useState, useRef } from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import ScreenWrapper from "@hoc/ScreenWrapper";
import { Theme, ThemedText, ThemedView } from "@app/theme";
import CommonHeader from "@sharedComponents/Header/Header";
import Stepper from "@sharedComponents/Stepper/Stepper";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import KYCPhotoCamera from "../../../../assets/Icons/KYCPhotoCamera";
import { useTheme } from "@shopify/restyle";
import CameraPickerWeb from "./cameraPicker/CameraPickerWeb";
import { getStepper } from "@screens/VerifyBankAccount/services/verifyBankService";
import { PhotoPreview } from './components/PhotoPreview';
import { PhotoInstructions } from './components/PhotoInstructions';
import { PhotoActionButton } from './components/PhotoActionButton';
import { FailureCard } from './components/FailureCard';
import { SuccessCard } from './components/SuccessCard';
import { handlePhotoUpload } from './services/handlePhotoUpload';
import { useFocusEffect } from "@react-navigation/native";
import { useSuccessLottie } from "@hooks/useSuccessLottie";
import { Linking, Platform, ScrollView, StyleSheet } from 'react-native';
import { getNextRoute } from '../../../../src/navigationApp/navigationUtil';
import MFDShareLink from './mfdShareLink';
import { getParameters, isFromMFDShareLinkJourneyPartnerSide, removeQueryFromUrlWithoutReloadV2, shareLinkAllowedPlatform } from '@app/utils/utils';
import { CONTEXT, QUERY_PARAMS } from '@app/configs/constants';
import ROUTE from '@app/navigationApp/routes';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import Button from '@app/sharedComponents/Button/Button';
import { generateShareLinkV2Utils } from './mfdShareLink/utils';
import Clipboard from '@react-native-clipboard/clipboard';
import Whatsapp from '@app/assets/svg/Whatsapp';
import Copy from '@app/assets/svg/Copy';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import { Camera, useCameraDevices } from 'react-native-vision-camera'
import CameraPickerMobile from './cameraPicker/CameraPickerMobile';


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_PHOTO_VERIFICATION'>;

const KYCPhotoVerification: React.FC<ScreenProps> = ({ navigation, route }) => {
    const [stepperData, setStepperData] = useState<any>([]);
    const { userDetails } = useAppSelector(state => state.auth);
    const [pageLoader, setPageLoader] = useState(false);
    const { colors } = useTheme<Theme>();
    const [openCamera, setOpenCamera] = useState(false);
    const [userPhoto, setUserPhoto] = useState('');
    const [ctaLoader, setCTALoader] = useState(false);
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    const [showFailureCard, setShowFailureCard] = useState(false);
    const [errorDetails, setErrorDetails] = useState({
        title: '',
        message: ''
    });
    const [showPhotoMismatch, setShowPhotoMismatch] = useState(false)
    const [clickPhotoAgain, setClickPhotoAgain] = useState(false)
    const [capturePhotoOnDeviation, setCapturePhotoOnDeviation] = useState(false)
    const [previousPhoto, setPreviousPhoto] = useState<string>('');
    const [lastPhoto, setLastPhoto] = useState<string>('');
    const [reTriggerCamera, setRetriggerCamera] = useState(false)
    const [nextStepId, setNextStepId] = useState('')
    const [stepStatusMap, setStepStatusMap] = useState<any>(null);
    const [applicationState, setApplicationState] = useState<any>(null);
    const [manualCTAClicked, setManualCTAClicked] = useState(false);
    const { lottie: successLottie } = useSuccessLottie();
    const autoNavigationTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [showPartnerView, setShowPartnerView] = useState(isFromMFDShareLinkJourneyPartnerSide());
    const isShareLinkFlow = isFromMFDShareLinkJourneyPartnerSide();
    const [contextfromApi, setContextfromApi] = useState<any>(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [copyLoading, setCopyLoading] = useState(false);
    const [whatsappLoading, setWhatsappLoading] = useState(false);
    const dispatch = useAppDispatch();

    let RNVC, RNFS, Camera, useCameraDevices, CameraDevice;
if (Platform.OS !== 'web') {
	RNFS = require('react-native-fs');
	RNVC = require('react-native-vision-camera');

	Camera = RNVC.Camera;
	useCameraDevices = RNVC.useCameraDevices;
	CameraDevice = RNVC.CameraDevice;
}

    // const { hasPermission, requestPermission } = useCameraPermission()

    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const hideStepper = Platform.OS === 'web' ? params?.isCustomer == 'true' : false;

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false)
            }, 3000)
        }
    }, [copied])

    useEffect(() => {
        if (autoNavigationTimeoutRef.current) {
            clearTimeout(autoNavigationTimeoutRef.current);
            autoNavigationTimeoutRef.current = null;
        }

        if (showSuccessCard && !manualCTAClicked) {
            autoNavigationTimeoutRef.current = setTimeout(() => {
                if (contextfromApi === CONTEXT.PARTNER.toLowerCase()) {
                    navigation.navigate(ROUTE.MFD_SHARE_LINK_END_JOURNEY);
                } else {
                    const nextRoute = getNextRoute(nextStepId, applicationState, stepStatusMap);
                    if (Platform.OS === 'web') {
                        navigation.navigate(getNextRoute(nextStepId, applicationState, stepStatusMap) as any)
                    } else {
                        navigation.reset({
                            index: 0,
                            routes: [{ name: "HOME" }, { name: 'KYC_STEPPER' }, {
                                name: nextRoute, params: {
                                    stepId: nextStepId,
                                    stepStatusMap: stepStatusMap,
                                    applicationState: applicationState
                                }
                            }]
                        })
                    }

                }
                setShowSuccessCard(false)
            }, 3000)
        }

        // Cleanup function to clear timeout if component unmounts
        return () => {
            if (autoNavigationTimeoutRef.current) {
                clearTimeout(autoNavigationTimeoutRef.current);
            }
        };
    }, [showSuccessCard, nextStepId, stepStatusMap, applicationState, manualCTAClicked]);

    useFocusEffect(
        React.useCallback(() => {
            if (route.params?.userPhoto && !userPhoto) {
                setUserPhoto(route.params.userPhoto);
            }
            setCapturePhotoOnDeviation(route.params?.capturePhotoOnDeviation);
        }, [route.params])
    );

    const handleCamera = () => {

        setLastPhoto(userPhoto);
        if (Platform.OS === 'web') {
            setOpenCamera(true);
        } else {
            Camera.getCameraPermissionStatus().then((res) => {
                console.log('getCameraPermissionStatus', res)
            setOpenCamera(true);
                
            })
            //  Linking.openSettings()
        }
    };
    const handleRetake = () => {
        setLastPhoto(userPhoto);
        setPreviousPhoto(userPhoto);
        setOpenCamera(true);
        setUserPhoto('');
        setClickPhotoAgain(true);
    };

    useEffect(() => {
        setPageLoader(true);
        const fetchInitialData = async () => {
            try {
                const response = await getStepper({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
                setStepperData(response);
            } catch (error) {
                console.log(error);
            } finally {
                setPageLoader(false);
            }
        };
        fetchInitialData();
        removeQueryFromUrlWithoutReloadV2(QUERY_PARAMS.OC);
        dispatch(updatePartnerParams({ showCall: true }))
    }, []);

    useEffect(() => {
        if (showPhotoMismatch) {
            navigation.navigate("KYC_PHOTO_MISMATCHH", { userPhoto: userPhoto });
            setShowPhotoMismatch(false)
            setUserPhoto('')
        }
    }, [showPhotoMismatch]);

    const handleCopyLink = async () => {
        setCopied(true);
        setCopyLoading(true);
        const link = await generateShareLinkV2Utils({ userDetails: userDetails });
        Clipboard.setString(link);
        setCopyLoading(false);
    }

    const handleShareWhatsapp = async () => {
        setWhatsappLoading(true);
        const link = await generateShareLinkV2Utils({ userDetails: userDetails });

        let borrowerName = userDetails?.user?.fullName;
        let referalLink = link;
        let partnerName = userDetails?.linkedPartnerAccounts[0]?.partnerName || 'testPartnerName';

        let message = `Dear ${borrowerName},\n\nAs part of the KYC process, please complete the selfie verification step at your earliest convenience. Click the link below to proceed:\n\n${referalLink}\n\nThis step is essential to finalize your application. If you have any questions, feel free to reach out. \n\nThank you,\n${partnerName}`;
        if (Platform.OS === 'web') {
            window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank')
        }
        setWhatsappLoading(false);
    }

    const shareModal = () => {
        return (
            <BottomSheetContainer
                isVisible={showShareModal}
                close={() => {
                    setShowShareModal(false)
                }}
                onClose={() => {
                    setShowShareModal(false)
                }}
                closeOnBackdropPress={false}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                showCloseIcon={true}
                dragComponent={<ThemedView style={{ width: 40, height: 4, backgroundColor: 'gray', borderRadius: 10 }} />}
                containerStyle={{ backgroundColor: 'white' }}
            >
                <ThemedView style={{ display: 'flex', flexDirection: 'column' }} padding={'lg'}>
                    <ThemedText variant={'h5s'} color={'text-primary'}>
                        {'Share link with customers'}
                    </ThemedText>
                    <ThemedView style={{ marginTop: 24 }} />
                    <Button
                        label={copied ? 'Link copied' : 'Copy link'}
                        type="SOLID"
                        size='MD'
                        disabled={false}
                        handlePress={() => {
                            handleCopyLink()
                        }}
                        showLeftAccessory={true}
                        leftAccessory={() => {
                            return <Copy size={16} color={'white'} />
                        }}
                        textColor={'white'}
                        buttonLoader={copyLoading}
                    />
                    <ThemedView style={{ marginTop: 16 }} />
                    <Button
                        label={'Share on WhatsApp'}
                        type="OUTLINED"
                        size='MD'
                        disabled={false}
                        handlePress={() => {
                            handleShareWhatsapp()
                        }}
                        showLeftAccessory={true}
                        leftAccessory={() => <Whatsapp />}
                        buttonLoader={whatsappLoading}
                    />
                </ThemedView>
            </BottomSheetContainer>
        )
    }


    // if (pageLoader) {
    //     return <PageLoader />
    // }

    return showPartnerView ? (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            <CommonHeader
                label="Upload selfie"
                navigation={navigation}
                pageName={route.name}
                hideBottomBorder={true}
            />
            <Stepper isLoading={pageLoader} stepperData={stepperData} />
            <ScrollView style={{ flex: 1, backgroundColor: colors['bg-surface-primary'] }}>
                <ThemedView backgroundColor="bg-surface-primary">
                    <MFDShareLink
                        onClickCaptureOnDevice={() => {
                            setShowPartnerView(false)
                        }}
                    />
                </ThemedView>
            </ScrollView>
        </ScreenWrapper>
    ) : (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            {(openCamera && !userPhoto) || capturePhotoOnDeviation || reTriggerCamera ? (

                Platform.OS === 'web' ? 
                <CameraPickerWeb
                    setUserPhoto={(photo: string) => {
                        setUserPhoto(photo);
                        setClickPhotoAgain(false);
                    }}
                    onCancel={() => {
                        setOpenCamera(false);
                        if (!userPhoto && lastPhoto) {
                            setUserPhoto(lastPhoto);
                        } else {
                            setUserPhoto(userPhoto)
                        }
                        setClickPhotoAgain(false);
                    }}
                    setCapturePhotoOnDeviation={setCapturePhotoOnDeviation}
                    previousPhoto={previousPhoto}
                    setCTALoader={setCTALoader}
                    setOpenCamera={setOpenCamera}
                    navigation={navigation}
                    setRetriggerCamera={setRetriggerCamera}

                /> : <ThemedView>
                   <CameraPickerMobile
                    onCancel={() => {
                        setOpenCamera(false);
                        if (!userPhoto && lastPhoto) {
                            setUserPhoto(lastPhoto);
                        } else {
                            setUserPhoto(userPhoto)
                        }
                        setClickPhotoAgain(false);
                    }}
                    onCaptured={(photo: string) => {
                        setUserPhoto(photo);
                        setClickPhotoAgain(false);
                    }}
                    setCTALoader={setCTALoader}
                    navigation={navigation}
                    setRetriggerCamera={setRetriggerCamera}
                    setOpenCamera={setOpenCamera}
                   />
                </ThemedView>
            ) : (
                <>
                    <CommonHeader
                        label="Upload selfie"
                        navigation={navigation}
                        pageName={route.name}
                        hideBottomBorder={true}
                        customGoBackAction={isShareLinkFlow ? () => {
                            setShowPartnerView(true)
                        } : undefined}
                    />
                            {
                                hideStepper
                                    ? <ThemedView style={{ height: 1 }} />
                                    : <Stepper isLoading={pageLoader} stepperData={stepperData} />
                            }
                    <>
                        <ScrollView style={{ backgroundColor: "white" }}>
                            <ThemedView backgroundColor="bg-surface-primary" flex={1} padding={'lg'}>

                                <ThemedView mt={'sm'}>
                                    {!userPhoto && <KYCPhotoCamera />}
                                    <ThemedText variant={'h5s'} mt={'xs'}>
                                        {userPhoto ? 'Upload selfie' : 'Capture selfie'}
                                    </ThemedText>
                                    {userPhoto ? (
                                        <PhotoPreview
                                            userPhoto={userPhoto}
                                            onRetake={handleRetake}
                                        />
                                    ) : (
                                        <PhotoInstructions />
                                    )}
                                </ThemedView>
                            </ThemedView>
                        </ScrollView>

                        <PhotoActionButton
                            hasPhoto={!!userPhoto}
                            onCapture={handleCamera}
                            onUpload={() => handlePhotoUpload({
                                userPhoto,
                                userDetails,
                                setCTALoader,
                                setShowSuccessCard,
                                setShowFailureCard,
                                setErrorDetails,
                                setShowPhotoMismatch,
                                setUserPhoto,
                                setNextStepId,
                                setStepStatusMap,
                                setApplicationState,
                                setContextfromApi
                            })}
                            isLoading={ctaLoader}
                            colors={colors}
                            showPartnerView={isShareLinkFlow}
                            onPressShareLink={() => {
                                setShowShareModal(true)
                            }}
                        />

                    </>

                    {showFailureCard && (
                        <FailureCard
                            errorTitle={errorDetails.title}
                            errorMessage={errorDetails.message}
                            setShowFailureCard={setShowFailureCard}
                            colors={colors}
                            setRetriggerCamera={setRetriggerCamera}
                        />
                    )}

                    {showSuccessCard && successLottie && (
                        <SuccessCard
                            setShowSuccessCard={setShowSuccessCard}
                            colors={colors}
                            nextStepId={nextStepId}
                            navigation={navigation}
                            successLottie={successLottie}
                            stepStatusMap={stepStatusMap}
                            applicationState={applicationState}
                            contextfromApi={contextfromApi}
                            setManualCTAClicked={setManualCTAClicked}
                        />
                    )}
                </>)}
            {shareModal()}
        </ScreenWrapper>
    );
};

export default KYCPhotoVerification;